import React from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        {children}
        <button 
          className="modal-close-button"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>,
    document.body
  );
};

export default Modal; 